import { combineReducers } from '@reduxjs/toolkit';
import { reducer as predefinedCardsList } from './services/list';

export const reducer = combineReducers({
  list: predefinedCardsList,
});
